// extracted by mini-css-extract-plugin
module.exports = {"responsiveVideo":"Teacher3dCarousel_responsiveVideo__3mkfz","stepperContainer":"Teacher3dCarousel_stepperContainer__2GvUc"};